<template>
    <span class="masked-text">
      <!-- tampilkan data -->
      {{ isVisible ? value : masked }}
  
      <!-- tombol toggle -->
      <i 
        v-if="toggle" 
        :class="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'" 
        class="ml-2 toggle-eye" 
        @click="toggleVisibility">
      </i>
    </span>
  </template>
  
  <script>
  export default {
    name: "MaskingViewData",
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      front: {
        type: Number,
        default: 1   // hanya 1 karakter depan
      },
      back: {
        type: Number,
        default: 1   // hanya 1 karakter belakang
      },
      toggle: {
        type: Boolean,
        default: true // bisa di-toggle atau tidak
      }
    },
    data() {
      return {
        isVisible: false
      };
    },
    computed: {
      masked() {
        if (!this.value) return "-";
        const str = String(this.value);
        if (str.length <= this.front + this.back) {
          return "*".repeat(str.length);
        }
        return (
          str.slice(0, this.front) +
          "*".repeat(str.length - (this.front + this.back)) +
          str.slice(-this.back)
        );
      }
    },
    methods: {
      toggleVisibility() {
        this.isVisible = !this.isVisible;
      }
    }
  };
  </script>
  
  <style scoped>
  .toggle-eye {
    cursor: pointer;
    color: #666;
  }
  .toggle-eye:hover {
    color: #000;
  }
  </style>


// WEBPACK FOOTER //
// src/components/masking-view-data.vue